import { iDraftRequest, iEmail } from "../../interfaces/emailModel";
import { Put, callApi, iRequest } from "../../utilities/apiCall";
import { addItem } from "../../utilities/localStore/indexDBCalls";
import { CallEmsApi } from "../EmsAPI/FetchExtension";
import { formatEmailList } from "./formatter";

export const createDraftId = async (ed: iEmail, EnquiryID: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        let draft: iDraftRequest = {
            To: convereMailstoList(formatEmailList(ed.to)),
            Cc: convereMailstoList(formatEmailList(ed.cc)),
            Bcc: convereMailstoList(formatEmailList(ed.bcc)),
            Subject: ed.subject!,
            EnquiryID: EnquiryID,
            Priority: 3,
        };

        let request: iRequest = {
            url: "Draft",
            method: "POST",
            headers: [{ key: "Content-Type", value: "application/json" }],
            body: JSON.stringify(draft),
            responseType: "json",
        };
        await callApi(request)
            .then(resp => {
                resolve(resp.id);
            })
            .catch(err => {
                reject(err);
            });
    });
};
export const updateDraftId = async (ed: iEmail): Promise<any> => {
    await saveDraftToIndexedDb({ ...ed, updateDate: new Date() });

    let draft: iDraftRequest = {
        To: convereMailstoList(formatEmailList(ed.to)),
        Cc: convereMailstoList(formatEmailList(ed.cc)),
        Bcc: convereMailstoList(formatEmailList(ed.bcc)),
        Subject: ed.subject!,
        Priority: ed.priority,
        AttachedMessages: ed.attachedMessages,
        IncludeEmbeddedMessageAttachments: ed.includeEmbeddedMessageAttachments == true ? true : false,
    };
    if (ed.includeEmbeddedMessageAttachments && ed.embeddedMessageId) {
        draft.IncludeEmbeddedMessageAttachments = ed.includeEmbeddedMessageAttachments;
        draft.EmbeddedMessageID = ed.embeddedMessageId;
    }
    let result = await CallEmsApi("PUT", `Draft/${ed.maildraftId}`, draft);
    return result;
};

export const getDraftId = async (ed: iEmail): Promise<any> => {
    // everytime we get the maildraft the date needs to be updated, when logged in there is a method that deletes old drafts
    await saveDraftToIndexedDb({ ...ed, updateDate: new Date() });
    return ed.maildraftId;
};

export const saveDraftToIndexedDb = (ed: iEmail, complete: boolean = false): Promise<any> => {
    return new Promise((resolve, reject) => {
        addItem("MailDrafts", { ...ed, updateDate: ed.updateDate ?? new Date() })
            .then(() => {
                resolve(true);
            })
            .catch(err => {
                reject(err);
            });
    });
};

export const convereMailstoList = (listOfEmails: string): Array<{ Name: string; Address: string }> => {
    if (listOfEmails == "") {
        return [];
    } else {
        listOfEmails = listOfEmails.replaceAll(",", ";");
        let allEmails = listOfEmails.split(";").map(item => {
            return { Name: "", Address: item.toString().trim() };
        });
        return allEmails;
    }
};
